import { createSelector } from 'reselect';
import { createMaybeSelector } from '@ally/data-selectors';
export var getDomainData = function (_a) {
    var _b;
    var customer = _a.customer;
    return (_b = customer.data) !== null && _b !== void 0 ? _b : null;
};
export var getCustomer = createMaybeSelector(getDomainData, function (data) { return data.customer; });
/**
 * These selectors return the loading state of the data
 * and a timestamp of when the data was last fetched.
 */
export var getDataStatus = function (_a) {
    var customer = _a.customer;
    return customer.status;
};
export var getDataLoadState = createSelector(getDataStatus, function (status) { return status.loadState; });
export var getDataTimeStamp = createSelector(getDataStatus, function (status) { return status.timeStamp; });
//# sourceMappingURL=base.js.map